import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component, isValidElement } from 'react';
import classnames from 'classnames';
import DateTool from '../utils/date';
import ConfigReceiver from '../config-receiver';

var CalendarMonthView = /*#__PURE__*/function (_Component) {
  _inherits(CalendarMonthView, _Component);

  var _super = _createSuper(CalendarMonthView);

  // 上次是否落点在当前月份内
  // 当前月份的dom
  function CalendarMonthView(props) {
    var _this;

    _classCallCheck(this, CalendarMonthView);

    _this = _super.call(this, props);
    _this.lastIn = false;
    _this.node = void 0;

    _this.anchor = function () {
      if (_this.node && _this.node.scrollIntoViewIfNeeded) {
        _this.node.scrollIntoViewIfNeeded();
      }
    };

    _this.renderDay = function (day, year, month, firstDay) {
      var _className;

      var _this$props = _this.props,
          prefixCls = _this$props.prefixCls,
          dateRender = _this$props.dateRender,
          onDateClick = _this$props.onDateClick;
      var date = new Date(year, month, day);
      var isToday = new Date().getFullYear() === year && new Date().getMonth() === month && new Date().getDate() === day;

      var status = _this.checkStatus(date);

      var txt = date && dateRender && dateRender(date) || '';

      if (_typeof(txt) === 'object') {
        if (! /*#__PURE__*/isValidElement(txt)) {
          console.warn('dateRender函数返回数据类型错误，请返回基本数据类型或者reactNode');
          txt = '';
        }
      }

      var className = (_className = {
        d6: (day + firstDay) % 7 === 0,
        d7: (day + firstDay) % 7 === 1
      }, _defineProperty(_className, "".concat(prefixCls, "__day--disabled"), status.disabled), _defineProperty(_className, "".concat(prefixCls, "__day--today"), isToday), _defineProperty(_className, "".concat(prefixCls, "__day--selected"), status.isSelected), _defineProperty(_className, "".concat(prefixCls, "__day--range"), status.isRange), _defineProperty(_className, 'range-start', status.rangeStart), _defineProperty(_className, 'range-end', status.rangeEnd), _defineProperty(_className, "firstday-".concat(firstDay), day === 1 && firstDay), _className);
      return /*#__PURE__*/React.createElement("li", {
        key: "".concat(year, "-").concat(month, "-").concat(day),
        className: classnames("".concat(prefixCls, "__day"), className),
        onClick: function onClick() {
          return !status.disabled && date && onDateClick && onDateClick(date);
        }
      }, txt && /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "__day__content")
      }, txt) || '');
    };

    _this.renderContent = function (year, month) {
      var data = DateTool.getCurrMonthInfo(year, month);
      var firstDay = data.firstDay,
          dayCount = data.dayCount;
      return Array.from({
        length: dayCount
      }).map(function (_item, i) {
        return _this.renderDay(i + 1, year, month, firstDay);
      });
    };

    _this.state = {
      value: props.value,
      dateMonth: props.dateMonth
    };
    _this.checkStatus = _this.checkStatus.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CalendarMonthView, [{
    key: "checkStatus",
    value: // 日期状态: 选中，区间
    function checkStatus(date) {
      var _this$props2 = this.props,
          min = _this$props2.min,
          max = _this$props2.max,
          disabledDate = _this$props2.disabledDate;
      var _this$state$value = this.state.value,
          value = _this$state$value === void 0 ? [] : _this$state$value;
      var disabled = date < DateTool.cloneDate(min, 'd', 0) || date > DateTool.cloneDate(max, 'd', 0);
      var res = {
        disabled: disabled || disabledDate && disabledDate(date),
        isSelected: value.some(function (item) {
          return DateTool.isOneDay(date, item);
        }),
        isRange: value.length > 1 && date > value[0] && date < value[value.length - 1],
        rangeStart: value.length > 1 && DateTool.isOneDay(date, value[0]),
        rangeEnd: value.length > 1 && DateTool.isOneDay(date, value[value.length - 1])
      };
      this.lastIn = this.lastIn || res.isSelected || res.isRange;
      return res;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          prefixCls = _this$props3.prefixCls,
          locale = _this$props3.locale;
      var dateMonth = this.state.dateMonth;
      var year = dateMonth.getFullYear();
      var month = dateMonth.getMonth();
      var monthKey = "".concat(year, "-").concat(month);
      var title = (locale === null || locale === void 0 ? void 0 : locale.yearText) === '年' ? year + locale.yearText + locale.months[month] : "".concat(locale === null || locale === void 0 ? void 0 : locale.months[month], " ").concat(year);
      return /*#__PURE__*/React.createElement("section", {
        key: monthKey,
        className: "".concat(prefixCls, "__month"),
        title: title,
        ref: function ref(n) {
          _this2.node = n;
        }
      }, /*#__PURE__*/React.createElement("ul", null, this.renderContent(year, month)));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      if ( // eslint-disable-next-line operator-linebreak
      'value' in nextProps && nextProps.value !== state.value || 'dateMonth' in nextProps && nextProps.dateMonth !== state.dateMonth) {
        return {
          value: nextProps.value,
          dateMonth: nextProps.dateMonth
        };
      }

      return null;
    }
  }]);

  return CalendarMonthView;
}(Component);

CalendarMonthView.displayName = 'CalendarMonthView';
CalendarMonthView.defaultProps = {
  prefixCls: 'za-calendar',
  value: [],
  dateMonth: new Date(),
  min: new Date(),
  max: new Date(),
  dateRender: function dateRender(date) {
    return date.getDate();
  },
  disabledDate: function disabledDate() {
    return false;
  }
};
export default ConfigReceiver('Calendar')(CalendarMonthView);